/**
 * RESERVED_HOT_PINK
 * Use this color to emphasize that a colour is either not defined or a state/variant is un-supported
 * Any element that appears in this color in PRODUCTION is a red-flag as this colour should only ever be
 * seen in DEVELOPMENT.
 */
export var RESERVED_HOT_PINK = '#FF69b4';